import React from "react";

interface SectionTitleProps {
  title: string;
  subtitle?: string;
}

const JoinOurTeamHeader: React.FC<SectionTitleProps> = ({
  title,
  subtitle,
}) => {
  return (
    <div className="flex flex-col md:flex-row justify-between items-center mb-[5rem]">
      <div className="max-w-[94rem] mb-[2.3rem] md:mb-0 w-full">
        <h5 className="text-[3.2rem] mb-[1.2rem] font-semibold">{title}</h5>
        {subtitle && <p className="text-[1.6rem] ">{subtitle}</p>}
      </div>
    </div>
  );
};

export default JoinOurTeamHeader;
